/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import styled from 'styled-components';
import { getTooltipStyles } from '@chegg-ui/tooltip';
export var ToggletipWrapper = styled.span.withConfig({
  componentId: "sc-1b07im2-0"
})(["position:relative;display:inline-block;"]);
export var ToggletipPane = styled.div.withConfig({
  componentId: "sc-1b07im2-1"
})(["", ""], function (_ref) {
  var position = _ref.position,
      isShown = _ref.isShown;
  return getTooltipStyles(position, isShown);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/toggletip/dist/esm/styles.js
// module id = 1630
// module chunks = 11